(function () {
  function getCardData(card) {
    return {
      productId: card.getAttribute('data-product-id'),
      productTitle: card.getAttribute('data-product-title'),
      price: card.getAttribute('data-product-price'),
      position: card.getAttribute('data-product-position'),
      collectionId: card.getAttribute('data-collection-id'),
      collectionTitle: card.getAttribute('data-collection-title')
    };
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href]');
    if (!link) return;

    var card = link.closest('[data-product-select]');
    if (!card) return;

    // Skip the add-to-cart / choose-options button and the quick-view trigger -
    // those aren't a product 'select', they're a different intent.
    if (link.classList.contains('product-card__atc')) return;
    if (link.hasAttribute('aria-controls')) return;

    if (
      window.Shopify &&
      window.Shopify.analytics &&
      typeof window.Shopify.analytics.publish === 'function'
    ) {
      window.Shopify.analytics.publish('product_card_click', getCardData(card));
    }
  }, true);
})();
